import { render, staticRenderFns } from "./EventItemsList.vue?vue&type=template&id=ddb38288&scoped=true&"
import script from "./EventItemsList.vue?vue&type=script&lang=js&"
export * from "./EventItemsList.vue?vue&type=script&lang=js&"
import style0 from "./EventItemsList.vue?vue&type=style&index=0&id=ddb38288&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddb38288",
  null
  
)

export default component.exports